import { z } from 'zod'

export const HolidayType = z.enum(['OPTIONAL', 'MANDATORY', 'CUSTOM'])
export type HolidayType = z.infer<typeof HolidayType>
